import { BaseApiRouteService } from "mrb/core";

class LoadioAlbumFileStreamApiRouteService extends BaseApiRouteService {
    constructor() {
        super("loadio/album-file-streams");
    }

    get(id, options) {
        return super.get(`${this.base}/{id}{?width,height}`, id, options);
    }
}

export default LoadioAlbumFileStreamApiRouteService;
